module.exports = __webpack_public_path__ + "assets/img/22_221.2a6c61fe.jpg";